/* eslint-disable @typescript-eslint/no-unused-vars */
import {
  makeStyles,
  tokens,
  Switch,
  Image,
  Link,
  Text,
  Menu,
  MenuTrigger,
} from '@fluentui/react-components';
import { WeatherMoonRegular, WeatherSunnyRegular, Person24Regular } from '@fluentui/react-icons';
import useConfigStore from '../../store/config';
import { useMsal } from "@azure/msal-react";
import { useEffect } from 'react';
//import axios from 'axios';
//import { API_BASE_URL } from '../../constants';


const ROLE_STORAGE_KEY = 'userRole';
const PERSONAL_PROGRAMS_STORAGE_KEY = 'userPersonalPrograms';

const fetchAndStoreRole = async (_email: string) => {
  try {
    // const res = await axios.get<{ roles: string[], personalPrograms: string }>(`${API_BASE_URL}/admin/role`, { params: { email } });
    // if (res.data) {
    //   console.log('Fetched role from API:', res.data);
    //   sessionStorage.setItem(ROLE_STORAGE_KEY, JSON.stringify(res.data.roles));
    //   sessionStorage.setItem(PERSONAL_PROGRAMS_STORAGE_KEY, JSON.stringify(res.data.personalPrograms));
    //   window.dispatchEvent(new CustomEvent('role-changed'));
    sessionStorage.setItem(ROLE_STORAGE_KEY, JSON.stringify(["Admin"]));
    sessionStorage.setItem(PERSONAL_PROGRAMS_STORAGE_KEY, JSON.stringify([])); 
    //}
  } catch (e) {
    console.error('Failed to fetch user role', e);
  }
};


const useStyles = makeStyles({
  header: {
    padding: 0,
    backgroundColor: "#768692",
    borderBottom: `1px solid ${tokens.colorNeutralStroke1}`,
    paddingTop: "8px",
    paddingBottom: "8px",
    height: "70px",
  },
  container: {
    display: 'flex',
    alignItems: 'center',
    height: '64px',
    padding: `0 ${tokens.spacingHorizontalL}`,
    justifyContent: 'space-between',
    backgroundColor: "#768692",
  },
  title: {
    margin: 0,
    fontSize: tokens.fontSizeBase600,
    fontWeight: tokens.fontWeightSemibold,
    color: tokens.colorNeutralForeground1,
  },
  actions: {
    display: 'flex',
    alignItems: 'center',
    gap: tokens.spacingHorizontalM,
  },
  userMenuTrigger: {
    display: 'flex',
    alignItems: 'center',
    cursor: 'pointer',
    padding: tokens.spacingHorizontalS,
    borderRadius: tokens.borderRadiusMedium,
    userSelect: 'none',
    color: '#fff',
    '& svg': {
      color: '#fff',
    },
    '&:hover, &:active, &:focus': {
      background: 'inherit',
      color: tokens.colorBrandForeground1,
      boxShadow: 'none',
      outline: 'none',
      '& svg': {
        color: tokens.colorBrandForeground1,
      },
    },
  },
  userName: {
    marginLeft: tokens.spacingHorizontalXS,
    fontSize: tokens.fontSizeBase400,
  },
  themeSwitch: {
    display: 'flex',
    alignItems: 'center',
    gap: tokens.spacingHorizontalXS,
    marginRight: '20px',
  },
  userButton: {
    backgroundColor: 'transparent',
    border: 'none',
    fontSize: '1.05rem',
  },
});

const Headerbar: React.FC = () => {
  const styles = useStyles();
  const { mode } = useConfigStore(state => state.themeConfig);
  const setThemeMode = useConfigStore(state => state.setThemeMode);

  const { instance, accounts } = useMsal();
  const user = accounts && accounts[0];

  useEffect(() => {
    if (user?.username) {
      const stored = sessionStorage.getItem(ROLE_STORAGE_KEY);
      const parsed = stored ? JSON.parse(stored) as string[] : null;
      // if (!parsed || !parsed.includes(user.username.toLowerCase())) {
      //   fetchAndStoreRole(user.username);
      // }
      if (!parsed || parsed.length === 0) {
        fetchAndStoreRole(user.username);
      }
    } else {
      sessionStorage.removeItem(ROLE_STORAGE_KEY);
    }
  }, [user]);

  const handleLogin = async () => {
     instance.loginRedirect();
    // const account = instance.getAllAccounts()[0];
    // if (account?.username) {
    //   fetchAndStoreRole(account.username);
    // }
  };


  return (
    <header className={styles.header}>
      <div className={styles.container}>
        <Link href='/' style={{ display: 'inline-block' }}>
          <Image
            src='/imc.svg'
            alt='Logo'
            width={70}
            height={70}
            style={{
              margin: "10px",
              cursor: "pointer"
            }}
          />
        </Link>
        <div className={styles.actions}>
          <div className={styles.themeSwitch}>
            <WeatherSunnyRegular />
            <Switch
              title="Toggle theme"
              aria-checked={mode === 'dark'}
              checked={mode === 'dark'}
              onChange={(_, data) => setThemeMode(data.checked ? 'dark' : 'light')}
            />
            <WeatherMoonRegular />
          </div>
          {/* Auth User Info / Login */}
          {user ? (
            <Menu>
              <MenuTrigger>
                <div className={styles.userMenuTrigger} tabIndex={0}>
                  <Person24Regular style={{ fontSize: 28 }} />
                  <Text className={styles.userName}>{user.name || user.username}</Text>
                </div>
              </MenuTrigger>
            </Menu>
          ) : (
            <div
              className={styles.userMenuTrigger}
              tabIndex={0}
              onClick={handleLogin}
              style={{ fontWeight: 500 }}
            >
              <Person24Regular style={{ fontSize: 28 }} />
              <Text className={styles.userName}>Anmelden</Text>
            </div>
          )}
        </div>
      </div>
    </header>
  );
};

export default Headerbar;
